import axios from 'axios';

export function userAction(url, parent, types) {
  return (dispatch) => {
    let preloader = document.getElementById("preloader");
    preloader.style.display = "block";
    axios.get(url)
      .then((response) => {
        return response.data;
      })
      .then((items) => {
        dispatch({type: types, items})
        preloader.style.display = "none";
      })
      .catch(error => {
        window.location=process.env.PUBLIC_URL + "/error";
      })
  };
}